import { mapState, mapActions, mapMutations } from 'vuex'
import Form from '@/utils/form'
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import firebase from 'firebase/app'
import 'firebase/firebase-messaging'

export default {
  computed: {
    ...mapState({
      user: state => state.auth.user,
      device: state => state.device.deviceDetails,
      isAuthenticated: state => state.auth.isAuthenticated
    })
  },
  watch: {
    isAuthenticated(auth) {
      if (auth) {
        this.cloudMessagingInit()
      }
    }
  },
  data: function() {
    return {
      cloudMessaging: null,
      cloudMessagingErr: new Form({})
    }
  },
  methods: {
    ...mapActions({
      storeDevice: 'device/storeDevice',
      addAlert: 'alert/addAlert'
    }),

    ...mapMutations({
      addNotification: 'notification/addNotification',
      addUnread: 'auth/addUnread'
    }),

    async cloudMessagingInit() {
      if (!this.isAuthenticated) return

      await FingerprintJS.load().then(fp => {
        fp.get().then(result => {
          const visitorId = result.visitorId

          if (firebase.messaging.isSupported()) {
            this.cloudMessaging = firebase.messaging()
            this.cloudMessaging.getToken().then(currentToken => {
              if (currentToken) {
                this.saveDevice({ token: currentToken, id: visitorId })
              } else {
                this.checkPermission()
              }
            })
          } else {
            // console.log(
            //   `This browser doesn't support the API's required to use the firebase SDK`
            // )
          }
        })
      })
    },

    async saveDevice(data) {
      await this.storeDevice(data)
        .then(data => {
          this.bindEvents()
        })
        .catch(error => {
          this.cloudMessagingErr.$handleError(error)
          this.addAlert({
            state: false,
            label: this.cloudMessagingErr.$errorMessage
          })
        })
    },

    bindEvents() {
      /**
       * Handle incoming messages. Called when:
       * - a message is received while the app has focus
       * - the user clicks on an app notification created by a service worker
       * `messaging.setBackgroundMessageHandler` handler.
       */
      this.cloudMessaging.onMessage(data => {
        // console.log(data)
        this.showNotification(data.data.payload, data.notification)
      })
    },

    showNotification(payload, notification) {
      let data = JSON.parse(payload)
      if (this.checkUser(data)) {
        this.addUnread()

        /* Append new notification data when on the My notifications page */
        if (payload && this.isOnNotification()) {
          this.addNotification(data)
        }

        /* Show push notification */
        if (notification) {
          /* eslint-disable no-new */
          new Notification(notification.title, {
            body: notification.body,
            icon: notification.image
          })
        }
      }
    },

    checkUser(notification) {
      return (
        this.user &&
        notification &&
        parseInt(this.user.id) === parseInt(notification.notifiable_id)
      )
    },

    checkPermission() {
      if (!('Notification' in window)) {
        // console.log('This browser does not support desktop notification');
      } else if (Notification.permission === 'granted') {
        //
      } else if (Notification.permission !== 'denied') {
        Notification.requestPermission()
      }
    },

    isOnNotification() {
      return this.$route
        ? this.$route.name === 'user.notifications-page'
        : false
    }
  },
  async created() {
    await this.cloudMessagingInit()
  }
}
